define('banner/execute-custom-banners',['require','exports','module','lib/auth/auth','plugins/router','api-access','lib/models/account/find-expiring-trial','lib/models/account/check-meetings-after-date','./engagement-engine-service','./custom-banners/settings','./custom-banners/trial-expire','./custom-banners/time-zone-warning','./custom-banners/terms-of-service','./custom-banners/eol-message','./custom-banners/add-organizers-banner','./custom-banners/meeting-lock-banner','./custom-banners/presenter-swap-banner','./custom-banners/hub-rollout-banner','react-banner-component'],function (require, exports, module) {
    var auth = require('lib/auth/auth');
    var router = require('plugins/router');
    var userApi = require('api-access').user;
    var config = module.config();

    var findExpiringTrial = require('lib/models/account/find-expiring-trial');
    var checkMeetingsAfterDate = require('lib/models/account/check-meetings-after-date');

    var engagementEngineService = require('./engagement-engine-service');
    var settings = require('./custom-banners/settings');
    var trialExpire = require('./custom-banners/trial-expire');
    var timeZoneWarning = require('./custom-banners/time-zone-warning');
    var termsOfService = require('./custom-banners/terms-of-service');
    var eol = require('./custom-banners/eol-message');
    var addOrganizersBanner = require('./custom-banners/add-organizers-banner');
    var meetingLockBanner = require('./custom-banners/meeting-lock-banner');
    var presenterSwapBanner = require('./custom-banners/presenter-swap-banner');
    var hubRolloutBanner = require('./custom-banners/hub-rollout-banner');
    var bannerComponent = require('react-banner-component');

    var bannerTypes = {
        ADD_ORGANIZERS: 'add-organizers',
        MEETING_LOCK: 'meeting-lock',
        PRESENTER_SWAP: 'presenter-swap'
    };

    var authenticatedBanners = function () {
        var token = auth.getToken();

        var selectBannerFromEngagementEngine = function (locale) {
            return engagementEngineService().then(function (engagementEngineResponse) {
                var engagementEngineMessage =
                    engagementEngineResponse.engagementMessage;
                var eventConfiguration = { eventName: 'mainPageBanner' };
                var bannerTelemetry = bannerComponent.createTelemetryFromExisting(
                    window.mixpanel,
                    eventConfiguration
                );
                if (engagementEngineMessage && engagementEngineMessage.showContent) {
                    switch (engagementEngineMessage.contentId) {
                        case bannerTypes.ADD_ORGANIZERS:
                            eventConfiguration.type = 'AddOrganizers';
                            addOrganizersBanner.initialize(
                                locale,
                                engagementEngineResponse,
                                bannerTelemetry
                            );
                            break;
                        case bannerTypes.MEETING_LOCK:
                            eventConfiguration.type = 'MeetingLock';
                            meetingLockBanner.initialize(
                                locale,
                                engagementEngineResponse,
                                bannerTelemetry
                            );
                            break;
                        case bannerTypes.PRESENTER_SWAP:
                            eventConfiguration.type = 'SimplifiedPresenter';
                            presenterSwapBanner.initialize(
                                locale,
                                engagementEngineResponse,
                                bannerTelemetry
                            );
                            break;
                        default:
                            break;
                    }
                } else {
                    userApi.settings().then(function (userSettings) {
                        if (userSettings.meetingHubControllableByUser || (userSettings.meetingHubControllableByUser === undefined && config.showHubRolloutBanner)) {
                            eventConfiguration.type = 'HubRollout';
                            hubRolloutBanner.initialize(
                                locale,
                                engagementEngineResponse,
                                bannerTelemetry
                            );
                        }
                    });
                }
            });
        };

        var initializeBanners = function (activeInstruction) {
            return new Promise(function (resolve, reject) {
                settings.initialize();
                eol.initialize(activeInstruction);

                if (activeInstruction && activeInstruction.config.id === 'meetings') {
                    trialExpire.initialize(findExpiringTrial, checkMeetingsAfterDate);
                    termsOfService.initialize();

                    userApi.settings().then(function (user) {
                        timeZoneWarning.initialize(user);
                    });

                    userApi.me().then(function (me) {
                        var locale = me.locale.split('_')[0];
                        selectBannerFromEngagementEngine(locale)
                            .then(function () {
                                resolve();
                            })
                            .catch(function (error) {
                                reject(error);
                            });
                    });
                }
            });
        };

        if (token) {
            router.activeInstruction.subscribe(initializeBanners);
            return initializeBanners(router.activeInstruction());
        }

        return new Promise().resolve();
    };

    return function () {
        return authenticatedBanners();
    };
});

